import React, { Component } from "react"
import SingleDatePicker from "react-dates/lib/components/SingleDatePicker"
import PropTypes from "prop-types"
import { translate } from "react-i18next"
import momentPropTypes from "react-moment-proptypes"
import { DATEFORMAT } from "../../constants"
import moment from "moment"
import styled, { keyframes } from "styled-components"

const YearNav = styled.span`
  margin-left: 5px;
  margin-right: 5px;
  cursor: pointer;
  color: #82888a;
  -webkit-text-stroke: 1px white;
`

class DatePicker extends Component {
  static propTypes = {
    autoFocus: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    maxValue: momentPropTypes.momentObj,
    minValue: momentPropTypes.momentObj,
    placeholderKey: PropTypes.string,
    selectedDate: momentPropTypes.momentObj
  }

  static defaultProps = {
    autoFocus: false,
    maxValue: null,
    minValue: null,
    placeholderKey: "Common.ChooseDate",
    selectedDate: null
  }

  state = {
    focused: this.props.autoFocus
  }

  dateOutsideValidRange = date => {
    if (this.props.minValue && date < this.props.minValue) return true
    if (this.props.maxValue && date > this.props.maxValue) return true

    return false
  }

  handleChange = date => {
    this.props.onChange(date)
  }

  renderYearMonthSection = ({ month, onMonthSelect, onYearSelect }) => (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div>
        <select
          value={month.month()}
          onChange={e => {
            onMonthSelect(month, e.target.value)
          }}
        >
          {moment.months().map((label, value) => <option value={value}>{label}</option>)}
        </select>
        <div>
          <YearNav
            className="fa fa-long-arrow-left"
            onClick={e => {
              onYearSelect(month, month.year() - 1)
            }}
          />
          {month.year()}
          <YearNav
            className="fa fa-long-arrow-right"
            onClick={e => {
              onYearSelect(month, month.year() + 1)
            }}
          />
        </div>
      </div>
    </div>
  )

  renderCalendarDay = () => {}

  render() {
    const { placeholderKey, selectedDate, t } = this.props
    return (
      <div className="date-picker-container">
        <SingleDatePicker
          date={selectedDate}
          displayFormat={DATEFORMAT}
          focused={this.state.focused}
          isOutsideRange={date => this.dateOutsideValidRange(date)}
          numberOfMonths={1}
          onDateChange={this.handleChange}
          onFocusChange={({ focused }) => this.setState({ focused })}
          placeholder={t(placeholderKey)}
          showClearDate
          showDefaultInputIcon
          small
          transitionDuration={90}
          verticalSpacing={10}
          renderMonthElement={this.renderYearMonthSection}
          renderCalendarInfo={this.renderCalendarDay}
          hideKeyboardShortcutsPanel={true}
        />
      </div>
    )
  }
}

export default translate()(DatePicker)



// WEBPACK FOOTER //
// ./src/components/inputs/DatePicker.jsx